export default __webpack_public_path__ + "static/media/register-matric.40061eb2.png";